export interface PlaceEventInteraction {
    user: { id: string; locale: string };
    item: { id: string; type: string };
    action: EventInteractions;
    adId: string;
    place: {
        id: number;
        name: string;
        position: number;
        page: number;
        context: any;
        tabKey: string;
        placementId: string;
        subInterface: {
            name: string;
            position: number;
        };
    };
}

export enum EventInteractions {
    Impression = 'impression',
    Click = 'click',
    Hover = 'hover',
}

export const PLACE_EVENT_INTERACTION = 'PlaceEventInteraction';

export interface EventInteraction {
    id: string;
    action: EventInteractions;
}
